import ReactPaginate from 'react-paginate';
import React from 'react';
import styled from 'styled-components';

import Arrow from '@espaceProImages/icon-arrow-left.inline.svg';
import { HollowButton } from '@espacePro/components/_common/HollowButton';
import { MAIN_BLUE } from '@espacePro/constants/admin-theme';
import media from '../../main-app/utils/mediaQueries';

const PaginateWrap = styled.div`
  color: ${MAIN_BLUE};
  ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 0;
    
    li {
      width: 24px;
      height: 24px;
      margin: 8px;
      display: inline-flex;
      font-size: 18px;
      line-height: 1.33;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      a {
        color: ${MAIN_BLUE};
        text-decoration: none;

        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
    }
    
    li.selected {
      color: white;
      width: 32px;
      height: 32px;
      background-color: ${MAIN_BLUE};
      border-radius: 14px;

      a {
        color: white;
      }
    }
    
    li.previous {
      flex: 1;
      justify-content: flex-start;
      flex-direction: row;

      &.disabled {
        visibility: hidden;
      }
    }
    
    li.next {
      flex: 1;
      justify-content: flex-end;
      flex-direction: row;

      &.disabled {
        visibility: hidden;
      }
    }
  }
`;

const NavButton = styled(HollowButton)`
  background: transparent;

  ${media.mobile`
    font-size: 0;
    border-radius: 5px;
    background-color: #4a90e2;
    border: none;
  `}
`;

const RightArrow = styled(Arrow)`
  width: 5px;
  height: 9px;
  margin-bottom: -1px;
  margin-left: 5px;
  fill: ${MAIN_BLUE};

  ${media.mobile`
    fill: #fff;
    margin-left: 0;
  `}
`;

const LeftArrow = styled(RightArrow)`
  margin-right: 5px;
  transform: scale(-1,1);
  
  ${media.mobile`
    fill: #fff;
    margin-right: 0;
  `}
`;

const Paginate = (props) => (
  <PaginateWrap data-testid="pagination">
    <ReactPaginate
      {...props}
      previousLabel={(
        <NavButton>
          <LeftArrow />
          Précédent
        </NavButton>
    )}
      nextLabel={(
        <NavButton>
          Suivant
          <RightArrow />
        </NavButton>
    )}
    />
  </PaginateWrap>
);

export { Paginate };
